module.exports = __webpack_public_path__ + "static/media/400379_01.a75269d7.png";